module.exports = __webpack_public_path__ + "static/media/bg-redeem.c3ce1c49.svg";